import { Card, Flex, InformationalLegends, Text, Title } from '@wyz/ui';
import * as React from 'react';
import { ContainerOrderStatusBadge } from '~/common/components';
import { Trans } from '~/common/context';
import type { IContainerOrder } from '~/common/types';

interface OrderInfoCardProps {
  order: Pick<
    IContainerOrder,
    'reference' | 'status' | 'currency' | 'incoterm'
  >;
}

export const OrderInfoCard: React.FC<OrderInfoCardProps> = ({ order }) => {
  return (
    <Card className='h-100'>
      <Card.Body className='space-y-2'>
        <Text
          heading='normal'
          weight='bold'
          color='secondary'
          className='text-truncate'
        >
          <Title
            heading='lg'
            weight='bold'
            className='text-truncate'
            id='order-number'
          >
            <Trans i18nKey='app.purchase.orders.table.order_number' /> {' : '}
            {order.reference}
          </Title>
        </Text>
        <Flex>
          <ContainerOrderStatusBadge status={order.status} />
        </Flex>
        <InformationalLegends.Container>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.common.currency' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='currency'>
              {order.currency}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.common.incoterm' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='incoterm'>
              {order.incoterm || '-'}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
        </InformationalLegends.Container>
      </Card.Body>
    </Card>
  );
};

export default OrderInfoCard;
